<template>
  <div class="d-flex align-center clickable"
       @click="navigateToFolder"
  >
    <ClosdFildersIcon :document="folder" class="mr-2" />
    <template v-if="folder.numbering">
      <span class="mr-1" data-locator="folder-numbering">{{ `${folder.numbering}` }}</span>
    </template>
    <div class="filderName" data-locator="folder-name">{{ folder.basename || folder.name }}</div>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'

import ClosdFildersIcon from '@/common/filders/ClosdFildersIcon.vue'
import {
  LOAD_FOLDERS_TREE,
  DELETE_SEARCH_RESULTS,
  GO_TO_FOLDER_PAGINATED,
} from '@/store/modules/documents/action_types'
import { DocumentsBreadcrumbActionTypes } from '@/store/modules/documents-breadcrumb/action_types'

export default {
  name: 'DocumentsTableItemFolderName',
  components: { ClosdFildersIcon },
  props: {
    folder: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState('documents', ['searchModeEnabled']),
  },
  methods: {
    ...mapActions('documents', [LOAD_FOLDERS_TREE, DELETE_SEARCH_RESULTS, GO_TO_FOLDER_PAGINATED]),
    ...mapActions('documentsBreadcrumb', [DocumentsBreadcrumbActionTypes.ADD_BREADCRUMB_ITEM]),
    async navigateToFolder () {
      if (this.searchModeEnabled) {
        await this.LOAD_FOLDERS_TREE(this.folder.id)
        this.DELETE_SEARCH_RESULTS()
      }

      this.ADD_BREADCRUMB_ITEM(this.folder)
      this.GO_TO_FOLDER_PAGINATED(this.folder.id)
    },
  },
}
</script>
